import React from "react";

// Components
import Magnetic from "../Magnetic/Magnetic";

// SCSS
import "./CustomAlert.scss";

const CustomAlert = ({ setHoveredElement, message, onClose }) => {
  return (
    <div className="CustomAlert">
      <div className="CustomAlert__Content">
        <p className="CustomAlert__Message">{message}</p>
        <Magnetic
          as="button"
          type="button"
          setHoveredElement={setHoveredElement}
          onClick={() => {
            setHoveredElement(null);
            onClose();
          }}
          className="CustomAlert__Button"
        >
          Okay
        </Magnetic>
      </div>
    </div>
  );
};

export default CustomAlert;
